module.exports = __webpack_public_path__ + "img/1.0522fbe7.jpg";